import { TYPES } from '../../common/constants';

const persistence = _ => next => action => {
  if (action.type === TYPES.AUTH_SIGN_IN_DONE) {
    if (localStorage.getItem('auth') !== JSON.stringify(action.payload.auth)) {
      localStorage.setItem('auth', JSON.stringify(action.payload.auth));
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('isSignedOut', false);
    }
  }
  return next(action);
}

export default persistence;
